import * as buttons from 'smg/buttons';
import * as errors from 'smg/errors';
import { InitGoogleCredentialHandler } from 'smg/googlesignin';
import { ModalHideError } from 'smg/modal';
import * as object from 'smg/object';
import { Phone } from 'smg/phone';
import QueryString from 'smg/querystring';
import { SafeReturnPath } from 'smg/url';
import { Relref } from '../hugo';
import * as login from '../login';

main();

function main() {
    const landingPage = SafeReturnPath(QueryString().get('return'), Relref('/dashboard'));

    InitGoogleCredentialHandler(landingPage);

    if (QueryString().get('return')) {
        const emailLink = document.querySelector('#login-email-link') as HTMLAnchorElement;
        emailLink.href = `${emailLink.pathname}?return=${encodeURIComponent(landingPage)}`;
    }

    const phone = document.querySelector('#phone') as HTMLInputElement;
    setTimeout(() => phone.focus());

    const form = document.querySelector('#login-form') as HTMLFormElement;
    const fieldset = form.querySelector('fieldset') as HTMLFieldSetElement;
    const confirm = form.querySelector('[type="submit"]') as HTMLButtonElement;
    const alert = form.querySelector('.alert') as HTMLElement;
    const heading = form.querySelector('h1') as HTMLHeadElement;

    alert.parentElement?.removeChild(alert);
    alert.classList.remove('d-none');

    const showAlert = (type: 'generic' | 'invalid-email' | 'email-unverified') => {
        const a = alert.cloneNode(true) as HTMLElement;
        const msg = a.querySelector(`.${type}`);
        msg?.classList.remove('d-none');

        heading.after(a);
    };

    const hideAlert = () => {
        const a = form.querySelector('.alert');
        a?.parentElement?.removeChild(a);
    };

    const p = new Phone(phone);

    form?.addEventListener('submit', async e => {
        e.preventDefault();

        hideAlert();

        fieldset.setAttribute('disabled', 'disabled');
        buttons.Start(confirm);

        const prompt = await login.PromptLoginCode({ phone: p });

        void prompt.createCode.finally(() => {
            fieldset.removeAttribute('disabled');
            buttons.Stop(confirm);
        });

        prompt.login.
            then(() => window.location.href = landingPage).
            catch(err => {
                if (errors.IsAxiosError(err) && errors.IsBindErrors(err.response?.data) && object.IsObject(err['response']) && 'phone' in err.response.data) {
                    errors.ShowError(err);
                } else if (err instanceof ModalHideError) {
                    return;
                } else {
                    showAlert('generic');
                }

                throw err;
            });
    });

    const googleBtn = document.querySelector('#google-cover-btn') as HTMLElement;

    googleBtn.addEventListener('click', () => {
        const hiddenGoogleBtn = document.querySelector('.g_id_signin') as HTMLElement;
        const googleTarget = hiddenGoogleBtn.querySelector('div[tabindex="0"]') as HTMLElement;

        googleTarget.dispatchEvent(new PointerEvent('click'));
    });
}